import React, {useState, useEffect} from 'react';
import {FormDefinition} from "lib/forms";
import FieldView from "components/FieldView";
import Form from "components/Form";
import {ModelFormField} from "components/ModelFormHOC";
import {useForm} from "lib/formHook";
import {useEstados, useGetCidades} from "lib/DataHooks/base";
import {IonButton} from "@ionic/react";
import ActionButton from "components/ActionButton";
import {actions} from "lib/app";
import {useAppDispatch} from "lib/hooks";
import {pessoaTipoChoices, ProprietarioController, ProprietarioObject} from "models/Proprietario";
import {PosCadastro, PreCadastro} from "./FormProprietarioEmbed";
import {AppUser} from "models/app";
import {ModalContent, ModalFooter} from "components/Modal";
import {getFormDefProprietario} from "./controller";

const formCadastro = (): FormDefinition => {
  const baseForm = getFormDefProprietario();
  delete baseForm.telefone;
  return baseForm;
};

interface CadastrarProps {
  user: AppUser;
  preCadastro: PreCadastro;
  posCadastro?: PosCadastro;
  instance?: ProprietarioObject;
  onClickBack: (values: PosCadastro) => void;
  onComplete: (instance: ProprietarioObject) => void;
  doNotInsert?: boolean;
}

const Cadastrar: React.FC<CadastrarProps> = (props) => {
  const {preCadastro, onClickBack, posCadastro,
    user, onComplete, instance, doNotInsert} = props;
  const [estado, setEstado] = useState<string>();
  const dispatch = useAppDispatch();
  const form = useForm(formCadastro(), {...posCadastro, ...preCadastro});
  const [saving, setSaving] = useState(false);

  const [estados, loadingEstados] = useEstados();
  const [cidades, loadingCidades] = useGetCidades({estado}, {
    enabled: !!estado,
  });

  // preload estado
  useEffect(() => {
    if (posCadastro) {
      const _estado= posCadastro.estado;
      if (_estado && !loadingEstados && !estado) {
        setEstado(_estado);
      }
    }
  }, [posCadastro, estado, estados, loadingEstados]);

  const onChangeEstado = (value: string) => {
    setEstado(value);
    form.setFieldValue('cidade', '');
  }

  const onSubmit = async () => {
    // validar
    const {success, values, messagesFlat} = form.validate();
    if (!success) {
      dispatch(actions.notifyError(messagesFlat.join('<br/>')));
      return;
    }

    const model = new ProprietarioController(user);
    // console.log('instance', instance);

    if (instance)
      model.setInstance(instance);
    model.setValues({...preCadastro, ...values});
    const {success: cleanSuccess, errors} = model.clean();
    if (!cleanSuccess) {
      dispatch(actions.notifyError(errors.getFlat().join('<br/>')));
      return;
    }

    // retornar valores para commit posterior se doNotInsert
    if (doNotInsert) {
      onComplete(model.getInstance());
      return;
    }

    setSaving(true);
    await model.save();
    setSaving(false);
    onComplete(model.getInstance());
  }

  return (
    <>
      <ModalContent>
        <div className="app-form-step-title">
            2. Complete o cadastro do proprietário
        </div>
        <div className="">
          <FieldView value={preCadastro.telefone} label="Telefone"/>
        </div>

        <Form form={form}>
          <ModelFormField field="nome" />

          <ModelFormField
            field="pessoa_tipo"
            options={pessoaTipoChoices.getChoices()}
            optionLabel="label"
            optionValue="value"
          />

          <ModelFormField
            field="estado"
            options={estados}
            optionLabel="uf"
            optionValue="uf"
            loading={loadingEstados}
            onChange={onChangeEstado}
          />

          <ModelFormField
            field="cidade"
            options={cidades}
            optionLabel="nome"
            optionValue="nome"
            loading={loadingCidades}
            disabled={!estado}
          />
        </Form>
      </ModalContent>

      <ModalFooter
        message="Complete o cadastro se possível. Clique em Prosseguir para continuar."
      >
        <div className="flex items-center gap-4">
          <IonButton
            color="light"
            disabled={saving}
            onClick={() => {
              onClickBack(form.values);
            }}
          >
            Alterar telefone
          </IonButton>

          <ActionButton
            onClick={onSubmit}
            loading={saving}
          >
            {doNotInsert ? 'Prosseguir' : 'Gravar'}
          </ActionButton>
        </div>
      </ModalFooter>
    </>
  );
}

export default Cadastrar;
